import { rendererTdArg } from '../BootstrapTable/ColumnSettings'

const dateRenderer = (_: rendererTdArg, __: string, timestamp: unknown) =>
  timestamp ? new Date(String(timestamp)).toLocaleDateString() : ''

export default dateRenderer
